<template>
  <div class="initView">
    <div class="initInfo">
      <div class="select">
        <p>欢迎登录 绿萝心理云平台</p>
        <p>请填写学校必填信息</p>
        <div class="grade">
          <p>请选择学校中包含的年级</p>
          <div class="primarySchool">
            <div :style="{ borderBottom: '0px solid #E9E9E9' }">
              <a-checkbox :indeterminate="indeterminate" @change="onCheckAllChange" :checked="checkAll">
                小学
              </a-checkbox>
            </div>
            <a-checkbox-group class="checkBox" :options="plainOptions" v-model="checkedList" @change="onChange" />
          </div>
          <div class="primarySchool">
            <div :style="{ borderBottom: '0px solid #E9E9E9' }">
              <a-checkbox :indeterminate="indeterminate1" @change="onCheckAllChange1" :checked="checkAll1">
                初中
              </a-checkbox>
            </div>
            <a-checkbox-group class="checkBox" :options="plainOptions1" v-model="checkedList1" @change="onChange1" />
          </div>
          <div class="primarySchool">
            <div :style="{ borderBottom: '0px solid #E9E9E9' }">
              <a-checkbox :indeterminate="indeterminate2" @change="onCheckAllChange2" :checked="checkAll2">
                高中
              </a-checkbox>
            </div>
            <a-checkbox-group class="checkBox" :options="plainOptions2" v-model="checkedList2" @change="onChange2" />
          </div>
          <div class="primarySchool">
            <div :style="{ borderBottom: '0px solid #E9E9E9' }">
              <a-checkbox :indeterminate="indeterminate3" @change="onCheckAllChange3" :checked="checkAll3">
                大学
              </a-checkbox>
            </div>
            <a-checkbox-group class="checkBox" :options="plainOptions3" v-model="checkedList3" @change="onChange3" />
          </div>
        </div>
      </div>
      <img src="@/assets/init.png" alt="" style="position: absolute; right: 0px;">
    </div>
    <div class="reset">
      <p>请重置学校账号密码</p>
      <div class="newPassword">
        <span>新密码：</span>
        <a-input placeholder="请输入" defaultValue="number" v-model="passWord"/>
      </div>
      <div class="again">
        <span>再次输入：</span>
        <a-input placeholder="请输入" defaultValue="number" v-model="checkPassWord"/>
      </div>
      <div class="error">
        <p v-show="show">两次输入的密码不同</p>
      </div>
      <a-button class="commit" type="primary" :disabled="isReady" @click="commit">提交</a-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import STUDENTFUN from '@/util/studentFun'
export default {
  name: 'initView',
  data () {
    return {
    show: false,
    passWord: null,
    checkPassWord: null,
    checkedList: [],
    checkedList1: [],
    checkedList2: [],
    checkedList3: [],
    indeterminate: false,
    indeterminate1: false,
    indeterminate2: false,
    indeterminate3: false,
    checkAll: false,
    checkAll1: false,
    checkAll2: false,
    checkAll3: false,
    fromState: false,
    plainOptions: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级'],
    plainOptions1: ['初一年级', '初二年级', '初三年级'],
    plainOptions2: ['高一年级', '高二年级', '高三年级'],
    plainOptions3: ['大学一年级', '大学二年级', '大学三年级', '大学四年级']
    }
  },
  computed: {
    ...mapState([
      'updateGrades',
      'changePassword',
      'teacherAdmin'
    ]),
    isReady(){
      if ((this.checkedList.length !== 0 || this.checkedList1.length !== 0 || this.checkedList2.length !== 0 || this.checkedList3.length !== 0) && (this.passWord !== null && this.passWord !== "")  && this.checkPassWord !== null && this.checkPassWord !== "") {
        // console.log(this.checkedList,this.checkedList1,this.checkedList2,this.checkedList3,this.passWord,this.checkPassWord)
        return false
      }else{
        return true
      }
    }
  },
  methods: {
    ...mapMutations([
      'setGradesMaxMin'
    ]),
    ...mapActions([
      'getUserInfo',
      'updateSchoolGrades',
      'updateTeacherPassWord'
    ]),
    onChange(checkedList) {
        this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
        this.checkAll = checkedList.length === this.plainOptions.length;
    },
    onChange1(checkedList) {
        this.indeterminate1 = !!checkedList.length && checkedList.length < this.plainOptions1.length;
        this.checkAll1 = checkedList.length === this.plainOptions1.length;
    },
    onChange2(checkedList) {
        this.indeterminate2 = !!checkedList.length && checkedList.length < this.plainOptions2.length;
        this.checkAll2 = checkedList.length === this.plainOptions2.length;
    },
    onChange3(checkedList) {
        this.indeterminate3 = !!checkedList.length && checkedList.length < this.plainOptions3.length;
        this.checkAll3 = checkedList.length === this.plainOptions3.length;
    },
    onCheckAllChange(e,) {
      Object.assign(this, {
          checkedList: e.target.checked ? this.plainOptions : [],
          indeterminate: false,
          checkAll: e.target.checked,
      })
    },
    onCheckAllChange1(e,) {
      Object.assign(this, {
          checkedList1: e.target.checked ? this.plainOptions1 : [],
          indeterminate1: false,
          checkAll1: e.target.checked,
      })
    },
    onCheckAllChange2(e,) {
      Object.assign(this, {
          checkedList2: e.target.checked ? this.plainOptions2 : [],
          indeterminate2: false,
          checkAll2: e.target.checked,
      })
    },
    onCheckAllChange3(e,) {
      Object.assign(this, {
          checkedList3: e.target.checked ? this.plainOptions3 : [],
          indeterminate3: false,
          checkAll3: e.target.checked,
      })
    },
    // check(checkPassWord){
    //   if (checkPassWord != this.passWord)
    //     this.show = true
    //   else
    //     this.show = false
    // },
    async commit(){
      if (this.passWord.length < 6) {
        this.$message.info('新密码不得小于六位~')
      } else {
        if (this.checkPassWord === this.passWord){
          this.show = false
          let grade = []
          if (this.checkedList.length !== 0){
            this.checkedList.map(item =>{
              grade.push(item)
            })
          }
          if (this.checkedList1.length !== 0){
            this.checkedList1.map(item =>{
              grade.push(item)
            })
          }
          if (this.checkedList2.length !== 0){
            this.checkedList2.map(item =>{
              grade.push(item)
            })
          }
          if (this.checkedList3.length !== 0){
            this.checkedList3.map(item =>{
              grade.push(item)
            })
          }
          let aaaf = (array) => { // 连续选择年级
            var isContinuityArray = true
            array.map((item, index) => {
              if (index < array.length - 1) {
                let current = array[index].id - 1
                if (array[index + 1].id !== current) {
                  isContinuityArray = false
                }
              }
            })
            return isContinuityArray;
          }
          if (aaaf(STUDENTFUN.gradeFunction(grade))) { // 判断所选年级是否连续
            let passwd = {
              uid: this.teacherAdmin.uid,
              oldPasswd: this.teacherAdmin.password,
              accountName: this.teacherAdmin.user_name,
              newPasswd: this.checkPassWord
            }
            await this.updateTeacherPassWord(passwd)
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            let result = {
              ROLE_ID: userInfo.role_id,
              SCHOOL_ID: userInfo.school_id,
              UID: this.teacherAdmin.uid,
              DATA: {
                MAX_GRADE: STUDENTFUN.gradeFunction(grade)[0].id,
                MIN_GRADE: STUDENTFUN.gradeFunction(grade)[grade.length - 1].id
              }
            }
            await this.updateSchoolGrades(result)
            if (this.updateGrades === true && this.changePassword === true){
              await this.getUserInfo()
              let gradeList = [STUDENTFUN.gradeFunction(grade)[grade.length - 1].id, STUDENTFUN.gradeFunction(grade)[0].id]
              this.setGradesMaxMin(gradeList)
              sessionStorage.setItem('gradeMaxMin', JSON.stringify(gradeList))
              this.$message.success('提交成功')
              this.$router.push('/deskView')
            } else{
              this.$message.error('提交失败')
            }
          } else {
            this.$message.info('请选择连续的年级~')
          }
        } else {
          this.show = true
        }
      }
    }
  }
}
</script>

<style>
.initView{
  height: auto;
  width: 1200px;
  padding-top: 140px;
  padding-bottom: 30px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.initView p{
  margin-top: 0;
  margin-block-start: 0;
  margin-block-end: 0;
}
.initView .initInfo{
  display: flex;
  position: relative;
}
.initView .initInfo .select>p:first-child{
  font-size:32px;
  font-weight:500;
  color:rgba(9,144,114,1);
  line-height:32px;
}
.initView .initInfo .select>p:nth-child(2){
  margin-top: 16px;
  font-size:16px;
  font-weight:400;
  color:rgba(140,140,140,1);
  line-height:16px;
}
.initView .initInfo .select .grade>p{
  margin-top: 50px;
  font-size:16px;
  font-weight:500;
  color:rgba(38,38,38,1);
  line-height:16px;
}
.initView .initInfo .select .grade>div{
  margin-top: 34px;
}
.initView .initInfo .select .grade .checkBox{
  margin-top: 18px;
}
.initView .reset{
  margin-top: 52px;
}
.initView .reset>div{
  margin-top: 16px;
}
.initView .reset>p:first-child{
  font-size:16px;
  font-weight:500;
  color:rgba(38,38,38,1);
  line-height:16px;
}
.initView .reset .error{
  height: 14px;
  margin-top: 24px;
}
.initView .reset .error>p{
  font-size:14px;
  font-weight:400;
  color:rgba(255,118,49,1);
  line-height:14px;
}
.initView .reset .ant-input-affix-wrapper{
  width: auto;
}
.initView .reset .newPassword>span:first-child{
  padding-right: 14px;
}
.initView .reset .ant-input{
  width: 250px;
  height: 38px;
}
.initView .reset .ant-btn-primary{
  margin-top: 50px;
  margin-bottom: 140px;
  width:82px;
  height:40px;
  background:rgba(9,144,114,1);
  border-radius:4px;
}
.initView .reset .ant-btn-primary[disabled]{
  background: #d9d9d9;
}
</style>
